/* CUSTOM JS */

/* Little fix for header */
document.querySelectorAll(".header__primary-nav-item").forEach(elem => {
  elem.style.setProperty("--elem-size", `${elem.getBoundingClientRect().width}px`);
  elem.style.setProperty("--elem-left", `${elem.getBoundingClientRect().left}px`);
});


/* CUSTOM ELEMENT WHOLESALE */
if (!customElements.get('wholesale-card')) {
  class WholesaleCard extends HTMLElement {
    constructor() {
      super();
      
      // Define elements
      this.sizeInputs = this.querySelectorAll('.variant_selector_wrapper .size_input');
      this.quantityInputs = this.querySelectorAll('.quantity_selector_wrapper .quantity-selector');
      this.addToCartButton = this.querySelector('.submit_wrapper .add_to_cart_wholesale');
      this.totalPrice = this.querySelector('.submit_wrapper .total_price');

      // Bind events
      this.bindEvents();
    }

    bindEvents() {
      // Handle size input change
      this.sizeInputs.forEach(input => {
        input.addEventListener('click', () => {
          // Handle size inputs display
          this.sizeInputs.forEach(i => i.removeAttribute("selected"));
          input.setAttribute("selected", "true");

          // Handle quantity inputs display
          this.quantityInputs.forEach(i => {
            if (input.dataset.variantId === i.dataset.variantId) {
              i.setAttribute("selected", "true");
            } else {
              i.removeAttribute("selected")
            }
          });
        });
      });

      // Handle quantity input change
      this.quantityInputs.forEach(input => {
        input.addEventListener('change', this.updateSubmitButton.bind(this));
      });

      // Handle add to cart button click
      this.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));
    }

    updateSubmitButton() {
      let totalPrice = 0;
      let hasVariantToAdd = false;

      this.quantityInputs.forEach(input => {
        const quantity = parseInt(input.quantity) || 0;

        if (quantity > 0) {
          hasVariantToAdd = true;
          const price = parseFloat(input.dataset.price) || 0;
          totalPrice += quantity * price;
        }
      });

      // Update total price display
      this.totalPrice.textContent = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(totalPrice);
      // Enable or disable the submit button
      this.addToCartButton.disabled = !hasVariantToAdd;
    }

    resetQuantityInputs() {
      this.quantityInputs.forEach(input => {
        input.quantity = 0; // Reset quantity to 0
      });
    }

    handleAddToCart() {
      const items = [];
      this.quantityInputs.forEach(input => {
        const quantity = parseInt(input.quantity) || 0;
        if (quantity > 0) {
          items.push({
            id: input.dataset.variantId,
            quantity: quantity
          });
        }
      });

      if (items.length > 0) {
        // Add items to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
        .then(async response => {
          if (!response.ok) {
            const error = await response.json();
            console.log(error)
            throw new Error(error.description || 'Erreur inconnue');
          }
          return response.json()
        })
        .then(_ => {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          document.getElementById("cart-drawer")?.show();
          this.resetQuantityInputs();
        })
        .catch(error => {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          document.getElementById("cart-drawer")?.show();
          alert(error);
        });
      }
    }
  }

  customElements.define('wholesale-card', WholesaleCard);
}

if (!customElements.get('wholesale-table')) {
  class WholesaleTable extends HTMLElement {
    constructor() {
      super();
      
      // Define elements
      this.quantityInputs = this.querySelectorAll('.quantity-selector');
      this.addToCartButton = this.querySelector('.wholesale-add-to-cart');
      this.totalPrice = this.querySelector('.wholesale-add-to-cart .total_price');

      // Bind events
      this.bindEvents();
    }

    bindEvents() {
      // Handle quantity input change
      this.quantityInputs.forEach(input => {
        input.addEventListener('change', this.updateAllPrice.bind(this));
      });

      // Handle add to cart button click
      this.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));
    }

    updateAllPrice() {
      let totalPrice = 0;
      let hasVariantToAdd = false;

      this.quantityInputs.forEach(input => {
        const quantity = parseInt(input.quantity) || 0;

        // Update subtotal price for each variant
        const price = parseFloat(input.dataset.price) || 0;
        const subtotalPriceElement = input.closest('tr').querySelector('.variant-subtotal');

        if (subtotalPriceElement) {
          const subtotalPrice = quantity * price;
          subtotalPriceElement.textContent = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(subtotalPrice);
        }

        if (quantity > 0) {
          hasVariantToAdd = true;
          totalPrice += quantity * price;
        }
      });

      // Update total price display
      this.totalPrice.textContent = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(totalPrice);
      // Enable or disable the submit button
      this.addToCartButton.disabled = !hasVariantToAdd;
    }

    resetQuantityInputs() {
      this.quantityInputs.forEach(input => {
        input.quantity = 0; // Reset quantity to 0
      });
    }

    handleAddToCart() {
      const items = [];
      this.quantityInputs.forEach(input => {
        const quantity = parseInt(input.quantity) || 0;
        if (quantity > 0) {
          items.push({
            id: input.dataset.variantId,
            quantity: quantity
          });
        }
      });

      if (items.length > 0) {
        // Add items to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
        .then(async response => {
          if (!response.ok) {
            const error = await response.json();
            console.log(error)
            throw new Error(error.description || 'Erreur inconnue');
          }
          return response.json()
        })
        .then(_ => {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          document.getElementById("cart-drawer")?.show();
          this.resetQuantityInputs();
        })
        .catch(error => {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          document.getElementById("cart-drawer")?.show();
          alert(error);
        });
      }
    }
  }

  customElements.define('wholesale-table', WholesaleTable);
}